import React from 'react'
import styles from './pupils-table.styles'
import injectSheet from 'react-jss'
import { Table, HeadCell } from 'pobble-components/dist/table'
import { withRouter } from 'react-router-dom'
import Button from 'pobble-components/dist/button'
import PupilEntry from '../pupil-entry/pupil-entry.container'

const PupilsTable = ({
  classes,
  pupils,
  allAction,
  everyoneSelected,
  changeSortKey,
  sortBy,
  actualPupilsListEmpty,
  showLoadMore,
  loadMoreAction,
  history,
  hideAllAction
}) => (
  <div className={classes.container}>
    <Table>
      <thead>
        <tr>
          <HeadCell>
            {!hideAllAction && (
              <span className={classes.selectAll} onClick={allAction}>
                All
              </span>
            )}
          </HeadCell>
          <HeadCell
            className={classes.nameCell}
            left
            ordered={sortBy.key === 'name' ? sortBy.direction : null}
            order={direction => changeSortKey('name', direction)}>
            Name
          </HeadCell>
          <HeadCell
            className={classes.alignLeft}
            ordered={sortBy.key === 'displayName' ? sortBy.direction : null}
            order={direction => changeSortKey('displayName', direction)}>
            Display name
          </HeadCell>
          <HeadCell
            ordered={sortBy.key === 'age' ? sortBy.direction : null}
            order={direction => changeSortKey('age', direction)}>
            Year
          </HeadCell>
          <HeadCell>Groups</HeadCell>
          <HeadCell
            ordered={sortBy.key === 'permission' ? sortBy.direction : null}
            order={direction => changeSortKey('permission', direction)}>
            Permission
          </HeadCell>
          <HeadCell>Work</HeadCell>
          <HeadCell>Passcode</HeadCell>
          <HeadCell />
        </tr>
      </thead>
      <tbody>
        {pupils.map(pupil => (
          <PupilEntry
            id={pupil.account.id}
            key={pupil.account.id}
            onPupilClick={() => history.push(`pupil/${pupil.account.id}`)}
          />
        ))}
      </tbody>
    </Table>
    {showLoadMore && (
      <div className={classes.loadMoreContainer}>
        <Button tall secondary action={loadMoreAction}>
          Show more pupils
        </Button>
      </div>
    )}
  </div>
)

export default withRouter(injectSheet(styles)(PupilsTable))
